import React, { useState, useMemo } from "react";
import { HydraTable, Modal } from "@peracto/peracto-ui";

import { GET_LIST, useClient } from "@peracto/client";

const UserImportStatusList = ({ data, filter, showAll }) => {
  const { client } = useClient();
  const [dataModal, setDataModal] = useState();

  const errorColumns = [
    {
      Header: "Error Message",
      accessor: "errors",
      id: "errorMessage",
      Cell: ({ cell: { value } }) =>
        value?.length > 0 ? value[0].message : "-",
    },
    {
      Header: "Error Data",
      accessor: "errors",
      id: "errorData",
      Cell: ({ cell: { value } }) =>
        value?.length > 0 ? (
          value[0].extra_data?.errors ? (
            value[0].extra_data?.errors?.map((error, idx) => (
              <p
                className="mb-0"
                key={`${error.property}_${error.message}_${idx}`}
              >
                {error.property}: {error.message}
              </p>
            ))
          ) : value[0].message ? (
            <p className="mb-0">{value[0].message}</p>
          ) : (
            "-"
          )
        ) : (
          "-"
        ),
    },
    {
      accessor: "data",
      Cell: ({ cell: { value } }) => (
        <button
          className="px-0 btn btn-link"
          onClick={() => setDataModal(value)}
        >
          Show Data
        </button>
      ),
    },
  ];

  const successColumns = [
    {
      Header: "Branch",
      accessor: "data",
      id: "branch",
      Cell: ({ cell: { value } }) => value?.branch || "-",
    },
    {
      Header: "Has FIFM",
      accessor: "data",
      id: "hasFifm",
      Cell: ({ cell: { value } }) => value?.hasFifm || "-",
    },
    {
      Header: "LKQ User ID",
      accessor: "data",
      id: "lkqUserId",
      Cell: ({ cell: { value } }) => value?.lkqUserId || "-",
    },
    {
      Header: "User Group",
      accessor: "data",
      id: "userGroup",
      Cell: ({ cell: { value } }) => value?.userGroup || "-",
    },
    {
      Header: "Has Haynes Pro",
      accessor: "data",
      id: "hasHaynesPro",
      Cell: ({ cell: { value } }) => value?.hasHaynesPro || "-",
    },
    {
      Header: "Account Number",
      accessor: "data",
      id: "accountNumber",
      Cell: ({ cell: { value } }) => value?.accountNumber || "-",
    },
    {
      Header: "Can Make Orders",
      accessor: "data",
      id: "canMakeOrders",
      Cell: ({ cell: { value } }) => value?.canMakeOrders || "-",
    },
    {
      Header: "Trading Country",
      accessor: "data",
      id: "tradingCountry",
      Cell: ({ cell: { value } }) => value?.tradingCountry || "-",
    },
  ];

  const additionalColumns = filter.successful ? successColumns : errorColumns;

  const columns = useMemo(
    () => [
      {
        Header: "User Email",
        accessor: "data",
        id: "email",
        Cell: ({ cell: { value } }) => {
          return value.email || "-";
        },
      },
      ...additionalColumns,
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filter.successful]
  );

  const onFetchData = (options) => {
    return client(GET_LIST, `import-lines`, {
      ...options,
      filter,
    });
  };

  return useMemo(
    () => (
      <>
        <HydraTable
          key={`hydra-table-${filter.successful}`}
          columns={columns}
          onFetchData={onFetchData}
          noResultsMessage="No errors!"
          initialData={data}
        />

        <Modal
          isVisible={!!dataModal}
          title="Showing Row Data"
          close={() => setDataModal(null)}
          buttons={[
            {
              type: "btn-outline-secondary",
              text: "Close",
              action: () => {
                setDataModal(null);
              },
            },
          ]}
        >
          {!!dataModal && (
            <table className="table text-left table-sm">
              {Object.entries(dataModal).map((entry, idx) => {
                return (
                  <tr key={`${entry[0]}_${idx}`}>
                    <td className={idx === 0 ? "border-top-0" : ""}>
                      <span className="font-weight-bold">{entry[0]}:</span>
                    </td>
                    <td className={idx === 0 ? "border-top-0" : ""}>
                      <span style={{ wordBreak: "break-all" }}>{entry[1]}</span>
                    </td>
                  </tr>
                );
              })}
            </table>
          )}
        </Modal>
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columns, dataModal, data]
  );
};

export default UserImportStatusList;
